import { Navigate, useParams } from 'react-router-dom'
import { PATHS } from '../../shared/config/paths'
import { DASHBOARD_INTRO, DASHBOARD_STEPS } from './content/dashboard'
import { HANDWERKER_NACH_GEWERK_INTRO, HANDWERKER_NACH_GEWERK_STEPS } from './content/handwerkerNachGewerk'
import { INSTALL_APP_INTRO, INSTALL_APP_STEPS } from './content/installApp'
import { KALENDER_ANSICHT_INTRO, KALENDER_ANSICHT_STEPS } from './content/kalenderAnsicht'
import { LOGIN_INTRO, LOGIN_STEPS } from './content/login'
import { NICHT_ERREICHT_INTRO, NICHT_ERREICHT_STEPS } from './content/nichtErreicht'
import { PLANUNGSBEDARF_INTRO, PLANUNGSBEDARF_STEPS } from './content/planungsbedarf'
import { REIHENFOLGE_HANDWERKER_INTRO, REIHENFOLGE_HANDWERKER_STEPS } from './content/reihenfolgeHandwerker'
import { TERMIN_ABLAUF_INTRO, TERMIN_ABLAUF_STEPS } from './content/terminAblauf'
import { TERMIN_PLANEN_INTRO, TERMIN_PLANEN_STEPS } from './content/terminPlanen'
import {
  DASHBOARD_SLUG,
  HANDWERKER_NACH_GEWERK_SLUG,
  INSTALL_APP_SLUG,
  KALENDER_ANSICHT_SLUG,
  LOGIN_SLUG,
  NICHT_ERREICHT_SLUG,
  PLANUNGSBEDARF_SLUG,
  REIHENFOLGE_HANDWERKER_SLUG,
  TERMIN_ABLAUF_SLUG,
  TERMIN_PLANEN_SLUG,
  findTopic,
} from './model/topics'
import { useNoIndex } from './model/useNoIndex'
import { DeviceStepsTopic } from './ui/DeviceStepsTopic'
import { GuideLayout } from './ui/GuideLayout'

const DEVICE_TOPICS: Record<string, Pick<Parameters<typeof DeviceStepsTopic>[0], 'intro' | 'steps'>> = {
  [LOGIN_SLUG]: { intro: LOGIN_INTRO, steps: LOGIN_STEPS },
  [TERMIN_ABLAUF_SLUG]: { intro: TERMIN_ABLAUF_INTRO, steps: TERMIN_ABLAUF_STEPS },
  [INSTALL_APP_SLUG]: { intro: INSTALL_APP_INTRO, steps: INSTALL_APP_STEPS },
  [KALENDER_ANSICHT_SLUG]: { intro: KALENDER_ANSICHT_INTRO, steps: KALENDER_ANSICHT_STEPS },
  [TERMIN_PLANEN_SLUG]: { intro: TERMIN_PLANEN_INTRO, steps: TERMIN_PLANEN_STEPS },
  [HANDWERKER_NACH_GEWERK_SLUG]: { intro: HANDWERKER_NACH_GEWERK_INTRO, steps: HANDWERKER_NACH_GEWERK_STEPS },
  [NICHT_ERREICHT_SLUG]: { intro: NICHT_ERREICHT_INTRO, steps: NICHT_ERREICHT_STEPS },
  [PLANUNGSBEDARF_SLUG]: { intro: PLANUNGSBEDARF_INTRO, steps: PLANUNGSBEDARF_STEPS },
  [REIHENFOLGE_HANDWERKER_SLUG]: { intro: REIHENFOLGE_HANDWERKER_INTRO, steps: REIHENFOLGE_HANDWERKER_STEPS },
  [DASHBOARD_SLUG]: { intro: DASHBOARD_INTRO, steps: DASHBOARD_STEPS },
}

const UserGuideTopicPage = () => {
  useNoIndex()
  const { slug } = useParams()
  const topic = findTopic(slug)
  const content = topic?.ready ? DEVICE_TOPICS[topic.slug] : undefined

  if (!topic || !content) {
    return <Navigate to={PATHS.userGuide} replace />
  }

  return (
    <GuideLayout crumb={topic.title}>
      <DeviceStepsTopic title={topic.title} {...content} />
    </GuideLayout>
  )
}

export default UserGuideTopicPage
